var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-round btn-sm ml-4",attrs:{"disabled":_vm.aml_disabled,"id":"check_aml"},on:{"click":_vm.check_aml}},[_vm._v(" "+_vm._s(_vm.$t("message.contracts.contract_check_contragent").split(" ")[0])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }